// @ts-nocheck

import React from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import styled, { keyframes } from 'styled-components';

const DURATION = 600;

const appear = keyframes`
  0% { transform: translate3d(0, 40%, 0); opacity: 0; }
  100% { transform: none; opacity: 1;  }
`;

const StyledTransitionGroup = styled(TransitionGroup)`
  .appear-enter {
    animation: ${appear} ${DURATION}ms ease-out forwards;
  }
  .appear-exit {
    display: none;
  }
`;

const AppearTransitionGroup = ({ children, uniqKey }) => (
  <StyledTransitionGroup>
    <CSSTransition key={uniqKey} timeout={{ enter: DURATION, exit: 0 }} classNames="appear">
      {children}
    </CSSTransition>
  </StyledTransitionGroup>
);

export default AppearTransitionGroup;
